import { Country, State } from 'country-state-city';
import type { PlaceAddress } from '@mr-website/schemas';

export interface ResolvedAddress {
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export function parseAddressResponse(components: PlaceAddress[]): ResolvedAddress {
  const find = (type: string, key: 'long_name' | 'short_name' = 'long_name') =>
    components.find((c) => c.types.includes(type))?.[key] ?? '';

  const countryIso = find('country', 'short_name');
  const stateIso = find('administrative_area_level_1', 'short_name');

  return {
    street: [find('street_number'), find('route')].filter(Boolean).join(' '),
    city: find('locality'),
    postalCode: find('postal_code'),
    country: Country.getCountryByCode(countryIso)?.name ?? countryIso,
    state: State.getStateByCodeAndCountry(stateIso, countryIso)?.name ?? stateIso,
  };
}
